import * as React from 'react';

import { LazyBreadcrumb } from '@europrocurement/flexy-components';

import { Box } from '@mui/material';
import Dashboard from '../Dashboard/Dashboard';

const Accueil = function () {
    return (
        <Box>
            <LazyBreadcrumb path={['', 'Accueil']} />

            <Dashboard />
        </Box>
    );
};
export default Accueil;
